import React from 'react';

import CookieBannerPanel from '@components/CookieBanner/shared/CookieBannerPanel';

interface PanelLegalNoticeProps {
  title: string;
  description: string;
}

const PanelLegalNotice = ({
  title,
  description
}: PanelLegalNoticeProps) => (
  <CookieBannerPanel.Root>
    <CookieBannerPanel.Title>{title}</CookieBannerPanel.Title>
    <CookieBannerPanel.Description parseHTML>{description}</CookieBannerPanel.Description>
  </CookieBannerPanel.Root>
);

export default PanelLegalNotice;
